export default __webpack_public_path__ + "static/media/VID_20190723_141152472.8409424f.mp4";